<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5b0toC/tc-custom/9780811741101.jpg?1728851645757" alt="This image is the cover for the book Monsters of Pennsylvania"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monsters of Pennsylvania
      </h1>
      <p class="bookDescription body article font2">
        <p>Pennsylvania is home to an assortment of odd creatures, and this volume features the best of the bunch. Bigfoot looms large here, trudging the wilds all throughout the state. Other cryptids featured are the gigantic Broad Top Snake, the bizarre Dogman of Westmoreland County, and Bessie, Lake Erie's resident monster. Reports of big cats, giant attacking thunderbirds, bloodsucking wolfmen, and mischievous, mine-dwelling--Tommyknockers are included.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patty A Wilson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stackpole Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f622735a